import MotionTween from 'motion-tween';
import { SECTION_EXPANDED_CLASS, ADD_ITEMS_CONTROL_HIDDEN_CLASS } from '../constants';

export default class JraAddComponent {
  constructor(element) {
    this.element = element;

    this.maxItems = 6;
    this.controlIndex = 0;
    this.animateTime = 175;
    this.motionTweenItems = [];
    this.multipleItemInputs = [];
    this.lastActiveItem = null;

    this.initJraAddComponent();
  }


  initJraAddComponent() {
    this.addSingleItemControl = this.element.querySelector('[data-jra-add-component="add-single-item-control"]');
    this.removeSingleItemControl = this.element.querySelector('[data-jra-add-component="remove-single-item-control"]');
    this.singleItemContent = this.element.querySelector('[data-jra-add-component="single-item-content"]');
    this.addItemsControl = this.element.querySelector('[data-jra-add-component="add-multiple-items-control"]');
    this.multipleItemsContent = [...this.element.querySelectorAll('[data-jra-add-component="multiple-items-content"]')];

    this.multipleItemsContent.forEach((item, index) => {
      JraAddComponent.checkToDisableFormInputs(item);
      const itemInputs = [...item.querySelectorAll('[data-jra-add-component="multiple-items-input"]')];
      this.multipleItemInputs.push(itemInputs);
      const removeItemControl = item.querySelector('[data-jra-add-component="remove-multiple-items-control"]');
      removeItemControl.addEventListener('click', () => this.removeItemsClickControl(index));
    });

    if (this.singleItemContent) {
      JraAddComponent.checkToDisableFormInputs(this.singleItemContent);
    }

    if (this.addSingleItemControl) {
      this.addSingleItemControl.addEventListener('click', this.singleItemClickControl);
      if (this.removeSingleItemControl) {
        this.removeSingleItemControl.addEventListener('click', this.singleItemClickControl);
      }
    } else {
      this.addItemsControl.addEventListener('click', this.addItemsClickControl);
    }

    this.checkActiveItems();
  }


  singleItemClickControl = () => {
    let start = 0;
    let end = 0;

    if (this.singleItemContent.classList.contains(SECTION_EXPANDED_CLASS)) {
      this.singleItemContent.classList.remove(SECTION_EXPANDED_CLASS);
      start = this.singleItemContent.offsetHeight;
    } else {
      this.singleItemContent.classList.add(SECTION_EXPANDED_CLASS);
      this.singleItemContent.style.height = 'auto';
      window.getComputedStyle(this.singleItemContent);
      end = this.singleItemContent.offsetHeight;
    }
    this.animate(start, end, this.singleItemContent);
  }


  addItemsClickControl = () => {
    const start = 0;
    let end = 0;

    for (let i = 0; i < this.multipleItemsContent.length; i += 1) {
      const isItemActive = this.multipleItemsContent[i].classList.contains(SECTION_EXPANDED_CLASS);

      if (!isItemActive) {
        this.multipleItemsContent[i].classList.add(SECTION_EXPANDED_CLASS);
        this.multipleItemsContent[i].style.height = 'auto';
        window.getComputedStyle(this.multipleItemsContent[i]);
        end = this.multipleItemsContent[i].offsetHeight;
        this.controlIndex = i;
        break;
      }
    }
    this.animate(start, end, this.multipleItemsContent[this.controlIndex], this.controlIndex);
    this.checkActiveItems();
  }


  removeItemsClickControl = (controlIndex) => {
    let start = 0;
    let end = 0;
    let lastActiveItemIndex;
    this.controlIndex = controlIndex;
    const multipleActiveItems = this.multipleItemsContent.filter(
      item => item.classList.contains(SECTION_EXPANDED_CLASS),
    ).length > 1;

    for (let i = this.multipleItemsContent.length - 1; i >= 0; i -= 1) {
      if (this.multipleItemsContent[i].classList.contains(SECTION_EXPANDED_CLASS)) {
        this.lastActiveItem = this.multipleItemsContent[i];
        lastActiveItemIndex = i;
        break;
      }
    }
    const isNotLastActiveItem
      = this.multipleItemsContent[this.controlIndex] !== this.lastActiveItem;

    if (multipleActiveItems && isNotLastActiveItem) {
      let previousItemIndex;

      for (let i = 0; i < this.multipleItemsContent.length; i += 1) {
        previousItemIndex = i - 1;

        if (i > this.controlIndex && i <= lastActiveItemIndex) {
          this.multipleItemInputs[previousItemIndex].forEach((input, index) => {
            input.value = this.multipleItemInputs[i][index].value;
          });
        }
      }

      start = this.multipleItemsContent[this.controlIndex].offsetHeight;
      end = 0;
      this.animate(
        start,
        end,
        this.multipleItemsContent[this.controlIndex],
        this.controlIndex,
        true,
      );
    } else {
      this.multipleItemsContent[this.controlIndex].classList.remove(SECTION_EXPANDED_CLASS);
      start = this.multipleItemsContent[this.controlIndex].offsetHeight;
      end = 0;
      this.animate(start, end, this.multipleItemsContent[this.controlIndex], this.controlIndex);
    }
    this.resetLastItemData(lastActiveItemIndex);
    this.checkActiveItems();
  }


  checkActiveItems = () => {
    // ignore if single item
    if (!this.addItemsControl) return;

    const isOneItemActive = this.multipleItemsContent.find(
      item => item.classList.contains(SECTION_EXPANDED_CLASS),
    );

    const allItemsActive = this.multipleItemsContent.filter(
      i => i.classList.contains(SECTION_EXPANDED_CLASS),
    ).length === this.maxItems;

    const addItemsControlHidden = this.addItemsControl.classList.contains(
      ADD_ITEMS_CONTROL_HIDDEN_CLASS,
    );

    this.toggleAddItemsControlDisplay(isOneItemActive, allItemsActive, addItemsControlHidden);
  }


  toggleAddItemsControlDisplay = (oneItemActive, allItemsActive, addItemsControlHidden) => {
    if (oneItemActive) {
      this.addItemsControl.classList.add(SECTION_EXPANDED_CLASS);
      if (addItemsControlHidden && !allItemsActive) {
        this.addItemsControl.classList.remove(ADD_ITEMS_CONTROL_HIDDEN_CLASS);
      }
    } else {
      this.addItemsControl.classList.remove(SECTION_EXPANDED_CLASS);
    }

    if (allItemsActive && !addItemsControlHidden) {
      this.addItemsControl.classList.add(ADD_ITEMS_CONTROL_HIDDEN_CLASS);
    }
  }


  resetLastItemData = (index) => {
    this.multipleItemInputs[index].forEach((input) => {
      input.value = '';
    });
  }


  togglePointerEvents = () => {
    if (this.isAnimating) {
      this.element.style.pointerEvents = 'none';
    } else {
      this.element.style.pointerEvents = 'auto';
    }
  }


  animate(startValue, endValue, item, index, reopenItem) {
    this.isAnimating = true;
    this.togglePointerEvents();
    let motionTweenItemIndex = 0;

    if (index) {
      motionTweenItemIndex = index;
    }

    let motionTween = this.motionTweenItems[motionTweenItemIndex];

    if (motionTween !== undefined) {
      motionTween.destroy();
    }

    motionTween = new MotionTween({
      startValue,
      endValue,
      time: this.animateTime,
      update: this.onUpdateTween(item),
      complete: this.setActiveState(item, reopenItem),
      animatorType: MotionTween.animatorType.ease,
      animatorOptions: {
        easingFunction: MotionTween.easingFunction.easeInOutQuad,
      },
      options: {

      },
    }).start();

    this.motionTweenItems[index] = motionTween;
  }


  onUpdateTween = item => (value) => {
    item.style.height = `${value}px`;
  }


  setActiveState = (item, reopenItem) => () => {
    if (item.offsetHeight > 0) {
      item.style.height = 'auto';
      JraAddComponent.enableFormInputs(item);
    } else {
      item.style.height = '0px';
      JraAddComponent.disableFormInputs(item);
    }

    if (reopenItem) {
      this.reopenItem();
    }

    this.isAnimating = false;
    this.togglePointerEvents();
  }


  reopenItem = () => {
    const start = 0;
    let end = 0;
    this.lastActiveItem.style.height = '0px';
    JraAddComponent.disableFormInputs(this.lastActiveItem);
    this.lastActiveItem.classList.remove(SECTION_EXPANDED_CLASS);
    this.multipleItemsContent[this.controlIndex].style.height = 'auto';
    end = this.multipleItemsContent[this.controlIndex].offsetHeight;
    this.animateTime = 0;
    this.animate(start, end, this.multipleItemsContent[this.controlIndex], this.controlIndex);
    this.animateTime = 175;
    this.checkActiveItems();
  }


  static disableFormInputs(container) {
    [...container.querySelectorAll('[data-form="input"]')].forEach((input) => {
      input.setAttribute('disabled', 'disabled');
    });
  }


  static enableFormInputs(container) {
    [...container.querySelectorAll('[data-form="input"]')].forEach((input) => {
      input.removeAttribute('disabled');
    });
  }


  static checkToDisableFormInputs(container) {
    if (container.classList.contains(SECTION_EXPANDED_CLASS)) {
      this.enableFormInputs(container);
    } else {
      this.disableFormInputs(container);
    }
  }
}
